export const CHANGE_CURRENT_STEP_4_INDIVIDUAL =
  "CHANGE_CURRENT_STEP_4_INDIVIDUAL";
export const CHANGE_CURRENT_STEP_4_INSTITUTION =
  "CHANGE_CURRENT_STEP_4_INSTITUTION";
export const CHANGE_ACCOUNT_EMAIL = "CHANGE_ACCOUNT_EMAIL";
export const CHANGE_APPLY_TYPE = "CHANGE_APPLY_TYPE";
export const SET_INSTITUTION_PERCENT_LIST = "SET_INSTITUTION_PERCENT_LIST";
